import React, { useEffect, useRef, useState } from "react";
import { get12HourTimeParts, normalizeTimeValue } from "./timeValue";

function parseTimeParts(value) {
  return get12HourTimeParts(value);
}

function build24HourTime(parts) {
  if (!parts.hour || !parts.minute || !parts.period) return "";

  const hour12 = Number(parts.hour);
  const minute = Number(parts.minute);
  if (!Number.isInteger(hour12) || hour12 < 1 || hour12 > 12) return "";
  if (!Number.isInteger(minute) || minute < 0 || minute > 59) return "";

  let hours24 = hour12 % 12;
  if (parts.period === "PM") hours24 += 12;
  return `${String(hours24).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
}

const HOUR_OPTIONS = Array.from({ length: 12 }, (_, index) => {
  const value = String(index + 1).padStart(2, "0");
  return { value, label: value };
});

const MINUTE_OPTIONS = Array.from({ length: 60 }, (_, index) => {
  const value = String(index).padStart(2, "0");
  return { value, label: value };
});

export default function TimeInput12Hour({ value, onChange, inputStyle = {} }) {
  const [parts, setParts] = useState(() => parseTimeParts(value));
  const lastExternalValueRef = useRef(normalizeTimeValue(value));

  useEffect(() => {
    const normalized = normalizeTimeValue(value);
    if (normalized === lastExternalValueRef.current) return;
    lastExternalValueRef.current = normalized;
    setParts(parseTimeParts(normalized));
  }, [value]);

  const updatePart = (key, nextValue) => {
    setParts((prev) => {
      const next = { ...prev, [key]: nextValue };
      if (key !== "period" && !next.period && (next.hour || next.minute)) {
        next.period = "AM";
      }
      const normalized = build24HourTime(next);
      lastExternalValueRef.current = normalized;
      onChange?.(normalized);
      return next;
    });
  };

  return (
    <div style={S.row}>
      <select style={{ ...S.select, ...inputStyle }} value={parts.hour} onChange={(event) => updatePart("hour", event.target.value)}>
        <option value="">HH</option>
        {HOUR_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>

      <select style={{ ...S.select, ...inputStyle }} value={parts.minute} onChange={(event) => updatePart("minute", event.target.value)}>
        <option value="">MM</option>
        {MINUTE_OPTIONS.map((option) => (
          <option key={option.value} value={option.value}>{option.label}</option>
        ))}
      </select>

      <select style={{ ...S.select, ...inputStyle }} value={parts.period} onChange={(event) => updatePart("period", event.target.value)}>
        <option value="">Period</option>
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}

const S = {
  row: {
    display: "grid",
    gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 0.9fr)",
    gap: 10,
    width: "100%",
  },
  select: {
    width: "100%",
    minWidth: 0,
    appearance: "none",
    WebkitAppearance: "none",
    MozAppearance: "none",
    backgroundColor: "#fff",
  },
};
